import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import React, { useState, useCallback, useEffect } from 'react';
import { getStyle } from './utils.es.js';

const PopupV1 = React.forwardRef((props, ref) => {
    const { commonStyle, maskStyle, position, children, show, displayOnVisitPage, delay, isEditorMode, displayOnScrollTo, displayOnExitPage } = props, rest = __rest(props, ["commonStyle", "maskStyle", "position", "children", "show", "displayOnVisitPage", "delay", "isEditorMode", "displayOnScrollTo", "displayOnExitPage"]);
    const [showPopup, setShowPopup] = useState(false);
    const [displayOnScrolToFlag, setDisplayOnScrolToFlag] = useState(false);
    const [displayOnExitFlag, setDisplayOnExitFlag] = useState(false);
    const handleOpenPopupOnExitPage = useCallback(() => {
        setShowPopup(true);
        setDisplayOnExitFlag(true);
    }, []);
    useEffect(() => {
        if (displayOnVisitPage && !isEditorMode) {
            setTimeout(() => setShowPopup(true), delay * 1000);
        }
    }, [displayOnVisitPage, delay, isEditorMode]);
    useEffect(() => {
        if (isEditorMode || !displayOnExitPage)
            return;
        if (!displayOnExitFlag) {
            document.body.addEventListener('mouseleave', handleOpenPopupOnExitPage);
        }
        else
            document.body.removeEventListener('mouseleave', handleOpenPopupOnExitPage);
    }, [displayOnExitFlag]);
    const handleScrollTo = useCallback(() => {
        const element = document.getElementById(displayOnScrollTo);
        if ((element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top) < window.scrollY && !showPopup) {
            setShowPopup(true);
            setDisplayOnScrolToFlag(true);
        }
    }, []);
    useEffect(() => {
        if (!displayOnScrolToFlag) {
            document.addEventListener('scroll', handleScrollTo);
        }
        else {
            document.removeEventListener('scroll', handleScrollTo);
        }
        return () => {
            document.removeEventListener('scroll', handleScrollTo);
        };
    }, [displayOnScrolToFlag]);
    return (jsxs(Mask, Object.assign({ className: show || showPopup ? 'show' : 'hide' }, { children: [jsx(Backdrop, { maskStyle: maskStyle, onClick: () => setShowPopup(false) }), jsx(Wrapper, Object.assign({ onClick: () => {
                    if (!showPopup)
                        setShowPopup(true);
                }, ref: ref, position: position, commonStyle: commonStyle }, rest, { children: children }))] })));
});
const getPosition = (position) => {
    switch (position) {
        case 'default':
            return `inset: 0;`;
        case 'topLeft':
            return `
            top: 0;
            left: 0;
        `;
        case 'topCenter':
            return `
            top: 0;
            left: 0;
            right: 0;
        `;
        case 'topRight':
            return `
            top: 0;
            right: 0;
        `;
        case 'centerLeft':
            return `
            top: 0;
            bottom: 0;
            left: 0;
        `;
        case 'centerRight':
            return `
            top: 0;
            bottom: 0;
            right: 0;
        `;
        case 'bottomLeft':
            return `
            bottom: 0;
            left: 0;
        `;
        case 'bottomCenter':
            return `
            bottom: 0;
            left: 0;
            right: 0;
        `;
        case 'bottomRight':
            return `
            bottom: 0;
            right: 0;
        `;
        default:
            return `inset: 0;`;
    }
};
const Wrapper = styled.div(({ commonStyle, position, }) => `
    position: absolute;
    z-index: 1050;
    margin: auto;
    max-width: 100%;
    ${getPosition(position)}
    ${getStyle(commonStyle)}
`);
const Mask = styled.div `
  position: fixed;
  inset: 0;
  z-index: 1000;
  &.hide {
    display: none;
  }
`;
const Backdrop = styled.div(({ maskStyle }) => `
 ${getStyle(maskStyle)}
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
z-index: -1000;
`);
PopupV1.displayName = 'PopupV1';

export { PopupV1 as P };
